import { IconSearch, Inline } from 'braid-design-system';

import ExternalLink from 'src/components/ExternalLink/ExternalLink';
import { ListingStatus } from 'src/generated/graphql';
import type { ClientListingForListingsTab } from 'src/types/graphql-derived';
import { createPreviewListingUrl } from 'src/utils';

import Action from './Action';
import { EditAction } from './EditAction';
import { PostActionLink } from './PostAction';

interface UnpostedViewProps {
  listing: ClientListingForListingsTab;
  setLoadingRedirect: () => void;
}

export const UnpostedView = ({
  listing,
  setLoadingRedirect,
}: UnpostedViewProps) => {
  const isPending = listing.status === ListingStatus.Pending;

  return (
    <Inline space="large">
      <ExternalLink
        destination={createPreviewListingUrl(listing.clientId, listing.id)}
      >
        <Action
          Icon={IconSearch}
          action="Preview"
          onClick={setLoadingRedirect}
        />
      </ExternalLink>

      {!isPending && (
        <PostActionLink
          listing={listing}
          setLoadingRedirect={setLoadingRedirect}
        />
      )}

      <EditAction listing={listing} onClick={setLoadingRedirect} />
    </Inline>
  );
};
